import { useEffect, useState } from "react";
import { getBaskets, getBasketById, getFarmById } from "../../Utils/storeService";

export default function useBasketDetails(id) {
  const [state, setState] = useState({ id, loading: true, basket: null, farm: null, relatedBaskets: [], error: false });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    const update = (values) => {
      if (active) setState((previous) => ({ ...previous, ...values }));
    };
    setState({ id, loading: true, basket: null, farm: null, relatedBaskets: [], error: false });

    const load = async () => {
      try {
        const found = await getBasketById(id);
        if (!active) return;
        if (!found) {
          update({ loading: false });
          return;
        }
        update({
          loading: false,
          basket: {
            ...found,
            price: Number(found.price || 0),
            description: found.description || "",
            image: found.imageUrl || null,
            items: Array.isArray(found.items) ? found.items : [],
            availableQuantity: found.availableQuantity ?? null,
          },
        });

        // Optional farm and related information must not hold up buying a basket.
        await Promise.allSettled([
          found.farmId
            ? getFarmById(found.farmId).then((farm) => update({ farm }))
            : Promise.resolve(),
          getBaskets(found.farmId).then((baskets) => update({
            relatedBaskets: (Array.isArray(baskets) ? baskets : [])
              .filter((basket) => String(basket.id) !== String(id))
              .slice(0, 4)
              .map((basket) => ({ ...basket, image: basket.imageUrl || null })),
          })),
        ]);
      } catch (error) {
        update({ loading: false, error: error?.response?.status !== 404 });
      }
    };

    load();
    return () => { active = false; };
  }, [id, attempt]);

  // Never show the previous basket during the render before the route effect runs.
  return {
    ...state,
    loading: state.loading || state.id !== id,
    retry: () => setAttempt((value) => value + 1),
  };
}
